// removed by extract-text-webpack-plugin
module.exports = {"Menu":"BuildingClass__Menu___2COcB","Additional":"BuildingClass__Additional___1jaHt","Title":"BuildingClass__Title___1iW2z","Checkboxes":"BuildingClass__Checkboxes___2gRgV","Checkbox":"BuildingClass__Checkbox___V-v61","Button":"BuildingClass__Button___3AyTs","FirstColumn":"BuildingClass__FirstColumn___1l4cp","SecondColumn":"BuildingClass__SecondColumn___3pKog","ButtonWrap":"BuildingClass__ButtonWrap___3Af9x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/BuildingClass/BuildingClass.scss
// module id = 1340
// module chunks = 0